import React from 'react';
import { connect } from 'react-redux';
import { initApp } from './actions/environmentActions';
import Modal from './Components/Modal';
import Spinner from './Components/Spinner';

class Messaging extends React.Component {
 
    componentDidMount(){
        this.props.init();     
        window.onMedefyAppResume = this.onMedefyAppResume;
    }

    onMedefyAppResume =()=>{
        this.props.init();
    }

    render() {

        const { isAuthenticated, isFetching } = this.props;

        return (
            <div>
                <div>
                    <div className="bg-app">
                        {isFetching && (
                            <Spinner />
                        )}
                        
                        {!isFetching && isAuthenticated && (
                            <div className="app-children" >
                                {this.props.children}
                            </div>
                        )}
                    </div>
                </div>

                <Modal />
            </div>
        )
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        init: () => {
            dispatch(initApp(true));
        }
    }
}

function mapStateToProps(state) {

    const { isAuthenticated } = state.thisApp.auth;
    const { isFetching } = state.thisApp.environment;
   
    return {
        isAuthenticated,
        isFetching
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Messaging);




// WEBPACK FOOTER //
// ./src/Messaging.js